import { ItemJob } from "../models/sales";

export const isItemME = (itemJob?: ItemJob) => {
  if (!itemJob) return false;

  return !!itemJob?.item?.mandatoryME || !!itemJob?.isMeCustom;
};
